<template>
    <slot />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AlwaysCheckRoles',
    enableRoleChecks: true,
});
</script>
